import {createContext, ReactNode, useContext, useMemo} from "react";

import {useUspListingTileExperiment} from "../../hooks/use_usp_listing_tile_experiment";
import {IOfferCardAddressContext} from "../../utils/get_offer_card_address";

interface IOfferListingUspAnalyticsContext {
    addressContext: IOfferCardAddressContext;
    variant: string | null;
}

interface IProps {
    addressContext: IOfferCardAddressContext;
    children: ReactNode;
}

const OfferListingUspAnalyticsContext = createContext<IOfferListingUspAnalyticsContext | null>(null);

export const OfferListingUspAnalyticsProvider = ({addressContext, children}: IProps) => {
    const {variant} = useUspListingTileExperiment();
    const value = useMemo(() => ({addressContext, variant}), [addressContext, variant]);

    return <OfferListingUspAnalyticsContext.Provider value={value}>{children}</OfferListingUspAnalyticsContext.Provider>;
};

export const useOfferListingUspAnalyticsContext = () => useContext(OfferListingUspAnalyticsContext);
import {createContext, ReactNode, useContext, useMemo} from "react";

import {useUspListingTileExperiment} from "../../hooks/use_usp_listing_tile_experiment";
import {IOfferCardAddressContext} from "../../utils/get_offer_card_address";

interface IOfferListingUspAnalyticsContext {
    addressContext: IOfferCardAddressContext;
    variant: string | null;
}

interface IProps {
    addressContext: IOfferCardAddressContext;
    children: ReactNode;
}

const OfferListingUspAnalyticsContext = createContext<IOfferListingUspAnalyticsContext | null>(null);

export const OfferListingUspAnalyticsProvider = ({addressContext, children}: IProps) => {
    const {variant} = useUspListingTileExperiment();
    const value = useMemo(() => ({addressContext, variant}), [addressContext, variant]);

    return <OfferListingUspAnalyticsContext.Provider value={value}>{children}</OfferListingUspAnalyticsContext.Provider>;
};

export const useOfferListingUspAnalyticsContext = () => useContext(OfferListingUspAnalyticsContext);
